var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: { centered: "", "hide-footer": "", "hide-header": "" },
      on: { hidden: _vm.onReset },
      model: {
        value: _vm.displayModal,
        callback: function ($$v) {
          _vm.displayModal = $$v
        },
        expression: "displayModal",
      },
    },
    [
      _c("div", { staticClass: "violations-create-modal" }, [
        _c(
          "svg",
          {
            staticClass: "violations-create-modal__close-icon",
            attrs: {
              width: "15",
              height: "16",
              viewBox: "0 0 15 16",
              fill: "none",
              xmlns: "http://www.w3.org/2000/svg",
            },
            on: { click: _vm.onReset },
          },
          [
            _c("path", {
              attrs: {
                d: "M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z",
                fill: "#8E9CBB",
              },
            }),
            _c("path", {
              attrs: {
                d: "M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z",
                fill: "#8E9CBB",
              },
            }),
          ]
        ),
        _c("div", { staticClass: "violations-create-modal__title" }, [
          _vm._v("Редактирование нарушения"),
        ]),
        _c("div", { staticClass: "violations-create-modal__row" }, [
          _c(
            "div",
            { staticClass: "violations-create-modal__item date-input" },
            [
              _c("c-input", {
                class: { "required-field": _vm.errorMessages.date },
                attrs: {
                  type: "date",
                  placeholder: "00.00.0000",
                  label: "Дата нарушения",
                  "icon-right": true,
                  icon: "calendar",
                  clearable: true,
                  required: _vm.errorMessages.date,
                  "required-condition": _vm.errorMessages.date,
                },
                model: {
                  value: _vm.form.date,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "date", $$v)
                  },
                  expression: "form.date",
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "violations-create-modal__row" }, [
          _c(
            "div",
            { staticClass: "violations-create-modal__item mb-0" },
            [
              _c("c-select", {
                staticClass: "violation-filter violation-filter__violations",
                class: { "required-field": _vm.errorMessages.violation },
                attrs: {
                  label: "Тип нарушения",
                  placeholder: "Все",
                  groups: _vm.collections.foulTypes.groups,
                  items: _vm.collections.foulTypes.items,
                  searchable: true,
                  clearable: true,
                  required: _vm.errorMessages.violation,
                  "required-condition": _vm.errorMessages.violation,
                },
                model: {
                  value: _vm.form.violation,
                  callback: function ($$v) {
                    _vm.$set(_vm.form, "violation", $$v)
                  },
                  expression: "form.violation",
                },
              }),
              _c("show-description", {
                attrs: {
                  value:
                    _vm.form.violation && _vm.form.violation.descriptionModel,
                },
              }),
            ],
            1
          ),
        ]),
        _c(
          "div",
          { staticClass: "violations-create-modal__actions" },
          [
            _c("responsive-apply-reset-actions", {
              attrs: {
                fixed: false,
                "disabled-but-clickable-submit": _vm.isSubmitDisabled,
              },
              on: { "on-submit": _vm.onSubmit, "on-reset": _vm.onReset },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }